import React from 'react'
import ResinousSystemList from './ResinousSystemList'
import AppNavigation from '../../AppNavigation'

export default function ResinousSystemSelection() {
   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
               <ResinousSystemList />
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousSystemSelection.js